import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "viewSARReport",
  class: "gd-user-details pt-gutter pb-gutter"
}
const _hoisted_2 = {
  key: 0,
  class: "mb-gutter"
}
const _hoisted_3 = {
  key: 0,
  class: "alert alert--error"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-alert" }, null, -1)
const _hoisted_5 = { class: "list-styled" }
const _hoisted_6 = {
  key: 1,
  class: "alert alert--error"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-alert" }, null, -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 3,
  id: "resultTable",
  class: "result-table"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", { class: "wrap-v-big" }, null, -1)
const _hoisted_12 = ["href"]
const _hoisted_13 = { style: {"padding-bottom":"8px"} }
const _hoisted_14 = { style: {"padding-bottom":"12px"} }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  type: "button",
  class: "button button--alt button--block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_reportform = _resolveComponent("v-reportform")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_export_excel = _resolveComponent("export-excel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", null, [
      (_ctx.initModel.modelErrors.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.authModel.isRequestAuthorized)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t("validationtext.validationHeading")), 1)
                  ]),
                  _createElementVNode("ul", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initModel.modelErrors, (error, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error), 1))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initModel.modelErrors, (error, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(error), 1))
                  }), 128))
                ]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.initModel.modelErrors.length)
        ? (_openBlock(), _createElementBlock("br", _hoisted_8))
        : _createCommentVNode("", true),
      (_ctx.authModel.isRequestAuthorized && _ctx.showReportForm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_v_reportform, {
              reportModel: _ctx.reportModel,
              "onUpdate:reportModel": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reportModel) = $event))
            }, null, 8, ["reportModel"]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getSearchResults && _ctx.getSearchResults(...args))),
              class: "button button--block"
            }, _toDisplayString(_ctx.$t("labeltext.reportSearch")), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_v_data_table, {
              headers: _ctx.headers,
              items: _ctx.searchResult,
              "items-per-page": _ctx.itemsPerPage,
              "items-per-page-options": _ctx.footerProps.itemsPerPageOptions,
              "footer-props": _ctx.footerProps,
              "item-key": "SARID",
              "fixed-header": "",
              dense: "",
              class: "table-styled table-styled-report"
            }, {
              [`item.SARID`]: _withCtx(({ item }) => [
                _createElementVNode("a", {
                  target: "_blank",
                  href: _ctx.navigateToDetailsPage(item.GUID)
                }, _toDisplayString(item.SARID), 9, _hoisted_12)
              ]),
              top: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("labeltext.reportRecords")), 1),
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.itemsPerPage) = $event)),
                      _cache[3] || (_cache[3] = ($event: any) => (_ctx.itemsPerPage = parseInt($event, 10)))
                    ],
                    class: "fixedWidth"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerProps.itemsPerPageOptions, (item, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item,
                        key: index
                      }, _toDisplayString(item), 9, _hoisted_15))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.itemsPerPage]
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["headers", "items", "items-per-page", "items-per-page-options", "footer-props"]),
            _createVNode(_component_export_excel, {
              data: _ctx.searchResult,
              fields: _ctx.exportColumns,
              type: "csv",
              name: "SAR Reports.csv"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_16, _toDisplayString(_ctx.$t("labeltext.reportDownload")), 1)
              ]),
              _: 1
            }, 8, ["data", "fields"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}